var path = 'login/redirect-page.tpl.html';
var html = " <md-content layout=row layout-align=\"center center\" style=width:100%> <div class=tk-login-redirect> <md-progress-linear md-mode=indeterminate class=md-warn></md-progress-linear> <div layout=row layout-align=\"center center\" layout-wrap style=margin-top:40px> <span>{{ 'login.loading' | translate }}</span> </div> </div> </md-content> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/login/redirect-page.tpl.html
// module id = 1540
// module chunks = 1